import type { SeoSegments } from '@handyhand/i18n';
import { buildContentPath, contentSlug } from '@helpers/contentPath';

interface ArticleLike {
  slug?: string;
  newSlug?: string;
  mainCategory?: { slug?: string };
  subCategory?: { slug?: string };
}

/**
 * Canonical path of an article, as the blog sitemap lists it:
 * `/{main}/{sub}/{slug}/a`, or `/{blog index}/{slug}` without a category.
 */
export function articlePath(
  article: ArticleLike,
  seoSegments: Pick<SeoSegments, 'suffix'>,
  blogIndexPath: string,
): string {
  const mainCategorySlug = article.mainCategory?.slug;
  const subCategorySlug = article.subCategory?.slug;
  if (!mainCategorySlug && !subCategorySlug) {
    const index = blogIndexPath.replace(/^\/+|\/+$/g, '');
    return `/${index}/${contentSlug(article)}`;
  }
  return buildContentPath({
    categories: [mainCategorySlug, subCategorySlug],
    slug: contentSlug(article),
    suffix: seoSegments.suffix.article,
  });
}
